import axios from "axios";
import { API_URL } from "../config/apiConfig";

const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
    };
};

export const getAffiliateEvents = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/affiliate-events`, {
        params: { affiliateId },
        headers: getAuthHeaders()
    });
    return response.data;
};

export const createEvent = async (payload) => {
    const response = await axios.post(`${API_URL}/events`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const updateEvent = async (eventId, payload) => {
    const response = await axios.put(`${API_URL}/events/${eventId}`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const deleteEvent = async (eventId) => {
    const response = await axios.delete(`${API_URL}/events/${eventId}`, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getPublicEvents = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/public-events`, {
        params: { affiliateId },
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getEventDetails = async (eventId) => {
    const response = await axios.get(`${API_URL}/events/${eventId}`, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const registerForEvent = async (eventId) => {
    const response = await axios.post(`${API_URL}/events/${eventId}/register`, {}, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const cancelEventRegistration = async (eventId) => {
    const response = await axios.delete(`${API_URL}/events/${eventId}/register`, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getEventRegistrants = async (eventId) => {
    const response = await axios.get(`${API_URL}/events/${eventId}/registrants`, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const addUserToEventByAdmin = async (eventId, userId) => {
    const response = await axios.post(`${API_URL}/events/${eventId}/add-user`, { userId }, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const updateEventRegistrationStatus = async (eventId, registrationId, status) => {
    const response = await axios.put(`${API_URL}/events/${eventId}/registrations/${registrationId}/status`, { status }, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const removeEventWaitlistEntry = async (eventId, waitlistEntryId) => {
    const response = await axios.delete(`${API_URL}/events/${eventId}/waitlist/${waitlistEntryId}`, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const emailEventRegistrants = async (eventId, payload) => {
    const response = await axios.post(`${API_URL}/events/${eventId}/email-registrants`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const createCreditEventCheckout = async (eventId) => {
    const response = await axios.post(`${API_URL}/events/${eventId}/checkout/credit`, {}, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const createMontonioEventCheckout = async (eventId, payload) => {
    const response = await axios.post(`${API_URL}/events/${eventId}/checkout/montonio`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getEventCheckoutStatus = async (params) => {
    const response = await axios.get(`${API_URL}/events/checkout/status`, {
        params,
        headers: getAuthHeaders()
    });
    return response.data;
};
